<template>
    <div class="main-content">
        <div class="uk-padding" v-if="preferences && preferences.generalData">
            <h1>Algemene Instellingen</h1>
            <div class="uk-margin">
                <label>Naam</label>
                <input class="uk-input" type="text" v-model="preferences.generalData.displayName" placeholder="Bedrijfsnaam">
            </div>
            <div class="uk-margin">
                <label>Website Link</label>
                <input class="uk-input" type="text" v-model="preferences.generalData.websiteLink" placeholder="Website Link">
            </div>
            <div class="uk-margin">
                <label>Signup Link</label>
                <input class="uk-input" type="text" v-model="preferences.generalData.signupPrefix" placeholder="Signup Link">
            </div>
            <div class="uk-margin">
                <label>Contact Email</label>
                <input class="uk-input" type="text" v-model="preferences.generalData.contactEmail" placeholder="Contact Email">
            </div>
            <div class="uk-margin">
                <label>No Reply Email</label>
                <input class="uk-input" type="text" v-model="preferences.generalData.noReplyEmail" placeholder="No Reply Email">
            </div>
            <div class="uk-margin">
                <label>Sendgrid Account Created Template</label>
                <input class="uk-input" type="text" v-model="preferences.generalData.accountCreatedTemplate" placeholder="Sendgrid Template ID">
            </div>
            <div class="uk-margin">
                <label>Sendgrid Contect Form Template</label>
                <input class="uk-input" type="text" v-model="preferences.generalData.contactedTemplate" placeholder="Sendgrid Template ID">
            </div>
            <div class="uk-margin">
                <button @click="update" :disabled="loading" class="uk-button uk-button-primary"><span v-if="!loading">Save</span><div v-if="loading" uk-spinner></div></button>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import {db} from '@/CUSTOM/helpers/firebase'
    export default {
        name: 'Configuratie',
        data () {
            return {
                preferences: null,
                loading: false
            }
        },
        methods: {
            update () {
                this.loading = true
                var promises = []
                Object.keys(this.preferences).forEach(k => {
                    promises.push(db.collection('preferences').doc(k).set(this.preferences[k], {merge: true}))
                })
                Promise.all(promises).then(res => {
                    this.loading = false
                }).catch(error => {
                    this.loading = false
                    throw error
                })
            }
        },
        created () {
           db.collection('preferences').onSnapshot((snap) => {
               this.preferences = {}
               snap.forEach(doc => {
                   Vue.set(this.preferences, doc.id, doc.data())
               })
               console.log(this.preferences)
               if(!this.preferences.generalData){
                   this.preferences.generalData = {}
               }
           })
        }
}
</script>


// WEBPACK FOOTER //
// Configuration.vue?1badb4dc